var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"mb-5",attrs:{"rounded":_vm.rounded,"outlined":_vm.outlined,"dense":!_vm.$_isMobile}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }